import React, { useCallback } from "react";
import { useFormContext } from "react-hook-form";

interface AsyncFormProps {
  onSubmit: (data) => Promise<boolean>;
  className?: string;
  name: string;
  dataContentName?: string;
}

function notifyMotomo(action, form) {
  if (typeof window._paq !== "undefined") {
    window._paq.push([`FormAnalytics::${action}`, form]);
  }
}

const AsyncForm: React.FC<React.PropsWithChildren<AsyncFormProps>> = ({
  className = undefined,
  children,
  name,
  onSubmit,
  dataContentName
}) => {
  const formRenderedRef = React.useRef<HTMLFormElement | undefined>(undefined);
  const { handleSubmit } = useFormContext();

  const formRef = useCallback((node: HTMLFormElement) => {
    if (node && formRenderedRef) {
      formRenderedRef.current = node;
      notifyMotomo("trackForm", formRenderedRef.current);
    }
  }, []);

  const onSubmitWithTracking = async (data) => {
    notifyMotomo("trackFormSubmit", formRenderedRef.current);
    const submitResult = await onSubmit(data);
    if (submitResult)
      notifyMotomo("trackFormConversion", formRenderedRef.current);
  };

  return (
    <form
      name={name}
      ref={formRef}
      onSubmit={handleSubmit(onSubmitWithTracking)}
      className={className}
      data-content-name={dataContentName}
    >
      {children}
    </form>
  );
};

export default AsyncForm;
